import { Breadcrumb, Button, Card, Table, Cell, Pagination, BookingStatusBadge, Input, Select, LoadingFullScreen } from 'components'
import { DateTime } from 'luxon'
import { getSearch, exportSearch } from 'api/search'
import { getClientDepartments, getClientDepartmentVenues, getBookingStatuses } from 'api/clients'

export const ClientSearch = ({ attrs: { filters } }) => {
  if (!filters) { filters = { page: 1, bookingType: 1, statusIds: [0, 1, 2], sortBy: 'arrival', sortOrder: 'desc', name: null, poNumber: null, search: null } }
  let bookings = []
  let meta
  let departments
  // let venues
  let statuses
  let criteriaReady = false
  let tableLoading = false
  let selectSearch
  let selectVenue
  let exportLoading = false

  Promise.all([
    getClientDepartments({ pagesize: 100 }),
    getBookingStatuses()
  ]).then(([d, s]) => {
    departments = d.data.map(row => {
      filters.clientId = row.clientId
      return { label: row.name, value: row.id, clientId: row.clientId }
    })
    // venues = v.data.map(row => {
    //   return { label: row.name, value: row.id }
    // })
    statuses = s.map(row => {
      return { label: row.name, value: row.id }
    })
    criteriaReady = true
  })

  const search = () => {
    bookings = []
    tableLoading = true
    getSearch(filters).then(data => {
      bookings = data.data
      meta = data.meta
      tableLoading = false
    })
  }

  // const refreshData = () => {
  //   getBookings(filters).then(data => {
  //     bookings = data.data
  //     meta = data.meta
  //   })
  // }

  return {
    view () {
      return [
        m(Breadcrumb, {
          links: [{
            title: 'Search'
          }]
        }),
        m('.my-4.px-4',
          [
            criteriaReady ? m('form', {
              onsubmit (e) {
                e.preventDefault()
                search()
              }
            }, [
              m(Card, {
                buttons: [
                  m(Button, {
                    type: 'button',
                    loading: exportLoading,
                    onclick () {
                      exportLoading = true
                      exportSearch(filters).then(() => {
                        exportLoading = false
                      })
                    }
                  }, 'Export'),
                  m(Button, {
                    type: 'submit',
                    loading: tableLoading
                  }, 'Search')]
              }, m('.grid.grid-cols-6.gap-4', [
                m('.col-span-2', [
                  m(Select, {
                    label: 'Select a department',
                    value: filters.departmentId,
                    choices: departments,
                    search: true,
                    required: false,
                    onchange (val, label) {
                      filters.departmentId = val
                      getClientDepartmentVenues(val, { pagesize: 1000 }).then(dv => {
                        const venues = dv.data.map(d => {
                          return {
                            label: d.venueName,
                            value: d.venueId
                          }
                        })
                        selectVenue.setChoices(venues, 'value', 'label', true)
                      })
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Select, {
                    label: 'Select a venue',
                    value: filters.venueId,
                    choices: [],
                    search: true,
                    required: false,
                    onchange (val, label) {
                      filters.venueId = val
                    },
                    instance (obj) {
                      selectVenue = obj
                    }
                  })
                ]),
                m('.col-span-5', [
                  m(Select, {
                    label: 'Select status(es)',
                    value: filters.statusIds,
                    choices: statuses,
                    search: true,
                    required: false,
                    subtype: 'multiple',
                    removeItemButton: true,
                    onchange (val) {
                      filters.statusIds = val
                    },
                    instance (obj) {
                      selectSearch = obj
                    }
                  })
                ]),
                m('.flex.items-end', [
                  m(Button, {
                    type: 'button',
                    size: 'sm',
                    onclick () {
                      selectSearch.removeActiveItems()
                      filters.statusIds = null
                    }
                  }, 'Clear all')
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Date from',
                    value: filters.fromDate,
                    type: 'date',
                    oninput (value) {
                      filters.fromDate = value
                    },
                    dateInstance (obj) {
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Date to',
                    value: filters.toDate,
                    type: 'date',
                    oninput (value) {
                      filters.toDate = value
                    }
                  })
                ]),
                m('div', [
                  m(Input, {
                    label: 'Nights from',
                    value: filters.nightsFrom,
                    type: 'number',
                    oninput (value) {
                      filters.nightsFrom = value
                    }
                  })
                ]),
                m('div', [
                  m(Input, {
                    label: 'Nights to',
                    value: filters.nightsTo,
                    type: 'number',
                    oninput (value) {
                      filters.nightsTo = value
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Name / Email',
                    value: filters.search,
                    type: 'text',
                    oninput (value) {
                      filters.search = value
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Reservation Code',
                    value: filters.reservationCode,
                    type: 'text',
                    oninput (value) {
                      filters.reservationCode = value
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'PO Number',
                    value: filters.poNumber,
                    type: 'text',
                    oninput (value) {
                      filters.poNumber = value
                    }
                  })
                ])
              ])
              )
            ]) : m(LoadingFullScreen),
            m('div.shadow.h-full.border-b.border-gray-200.sm:rounded-lg',
              m(Table, {
                tight: true,
                cols: [
                  {
                    label: 'Name'
                  },
                  {
                    label: 'Email',
                    filterClasses: 'hidden'
                  },
                  {
                    label: 'Department',
                    classes: ['w-24']
                  },
                  {
                    label: 'Venue'
                  },
                  {
                    label: 'Location',
                    classes: ['w-24']
                  },
                  {
                    label: 'Res Code',
                    classes: ['w-32 justify-center']
                  },
                  {
                    label: 'Arrival',
                    classes: ['w-24 justify-center']
                  },
                  {
                    label: 'Nights',
                    classes: ['w-20 justify-center']
                  },
                  {
                    label: 'Status',
                    classes: ['w-40 justify-center']
                  }
                ],
                filters: true,
                footer: meta && meta.totals
                  ? Object.keys(meta.totals).map(t => {
                    return [m('.flex', [m('span.font-bold', t + ':'), m('span.ml-1', meta.totals[t])])]
                  })
                  : false
              },
              [
                tableLoading ? m(LoadingFullScreen) : m('.overflow-auto.flex-grow',
                  bookings.length ? bookings.map((v, ix) => {
                    return m(BookingListItem, { item: v, key: v.id })
                  }) : m('p.text-center.p-3.text-gray-400', 'No results')
                ),
                meta && m(Pagination, {
                  meta: meta,
                  onpage: (page) => {
                    filters.page = page
                    getSearch(filters).then(data => {
                      bookings = data.data
                      meta = data.meta
                    })
                  }
                })
              ])
            )
          ])
      ]
    }
  }
}

const BookingListItem = ({ attrs: { item, classes = [], clientId, departmentId } }) => {
  const newFormat = { ...DateTime.DATE_SHORT, year: '2-digit' }
  return {
    view () {
      const rowColor = 'bg-white'
      return m('div', {
        class: ['flex', 'flex-shrink-0', 'hover:bg-gray-300', rowColor, ...classes].join(' ')
      }, [
        m(Cell, { tight: true }, m('span', item.name)),
        m(Cell, { tight: true, cellClasses: ['tracking-tight'] }, m('span', item.email)),
        m(Cell, { width: 'w-24', tight: true },
          item.departmentName
        ),
        m(Cell, { tight: true, cellClasses: ['tracking-tight'] },
          item.venueName
        ),
        m(Cell, { width: 'w-24', tight: true, cellClasses: ['tracking-tight'] },
          item.venueTownCity ? item.venueTownCity.split(' ').map((word) => {
            return word[0].toUpperCase() + word.substring(1).toLowerCase()
          }).join(' ') : ''
        ),
        m(Cell, { width: 'w-32', align: 'center', tight: true },
          item.reservationCode
        ),
        m(Cell, { width: 'w-24', align: 'center', tight: true },
          DateTime.fromISO(item.arrivalDate).toLocaleString(newFormat)
        ),
        m(Cell, { width: 'w-20', align: 'center', tight: true },
          item.nights
        ),
        m(Cell, { width: 'w-40', align: 'center', tight: true, noEllipsis: 'true' },
          m(BookingStatusBadge, {
            status: item.statusName, size: 'xs', margin: 'm-0'
          }
          )
        )
      ])
    }
  }
}
